var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.873 4.127a5.13 5.13 0 010 7.254l-2.26 2.259.033-.345c.06-.654.02-1.316-.122-1.96l-.015-.067 1.125-1.126a3.378 3.378 0 10-4.776-4.776l-3.539 3.538a3.378 3.378 0 001.793 5.713l.236.042-1.438 1.439-.076-.03a5.113 5.113 0 01-1.753-1.149 5.113 5.113 0 01-1.502-3.575v-.052A5.119 5.119 0 019.08 7.666l3.538-3.539a5.129 5.129 0 017.254 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.421 12.656a5.12 5.12 0 01-1.502 3.678l-3.538 3.539a5.13 5.13 0 01-7.254-7.254l2.26-2.259-.033.345c-.06.654-.02 1.316.122 1.96l.015.067-1.125 1.126a3.378 3.378 0 004.776 4.776l3.539-3.538a3.378 3.378 0 00-1.793-5.713l-.236-.043 1.438-1.438.076.03c.639.25 1.237.633 1.753 1.149a5.113 5.113 0 011.502 3.575z",
    fill: "currentColor"
  })));
}
export default SvgLinkFill;